module.exports = __webpack_public_path__ + "static/img/image061.a89e1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image061.png
// module id = QEnE
// module chunks = 1